import React from 'react';

const PromotionalBannerPreview = ({ banner }) => {
  if (!banner) {
    return (
      <div className="card shadow-sm border rounded-xl">
        <div className="card-body p-4">
          <div className="text-center text-muted py-5">
            <p className="mb-0">Fill in the form to see a preview</p>
          </div>
        </div>
      </div>
    );
  }

  const bgColor = banner.bgColor || '#000000';
  const textColor = banner.textColor || '#FFFFFF';
  const buttonColor = banner.buttonColor || '#FFFFFF';
  const buttonTextColor = '#000000'; // Default button text color (can be calculated based on button color)
  
  // Calculate image opacity (same logic as Flutter app)
  const imageOpacity = banner.imageOpacity !== undefined && banner.imageOpacity !== null
    ? banner.imageOpacity
    : (banner.imageUrl != null && banner.imageUrl !== '')
      ? 0.0 // Default to 0 opacity when background image is available
      : 0.3; // Fallback for overlay effect when no image
  
  // Helper function to determine if background is dark
  const isDarkColor = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  };

  // Calculate button text color based on button background
  const getButtonTextColor = () => {
    if (!buttonColor) return '#000000';
    try {
      return isDarkColor(buttonColor) ? '#FFFFFF' : '#000000';
    } catch {
      return '#000000';
    }
  };

  const buttonTextColorFinal = getButtonTextColor();
  
  // Apply width/height constraints if specified
  const bannerStyle = {
    position: 'relative',
    backgroundColor: bgColor,
    borderRadius: '12px',
    padding: '16px',
    minHeight: '120px',
    backgroundImage: banner.imageUrl 
      ? `url(${banner.imageUrl})` 
      : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
  
  if (banner.width && banner.width > 0) {
    bannerStyle.width = `${banner.width}px`;
  }
  if (banner.height && banner.height > 0) {
    bannerStyle.height = `${banner.height}px`;
    bannerStyle.minHeight = `${banner.height}px`;
  }

  return (
    <div className="card shadow-sm border rounded-xl">
      <div className="card-header bg-white border-bottom">
        <h5 className="mb-0 fw-semibold">Preview</h5>
      </div>
      <div className="card-body p-0">
        <div style={bannerStyle}>
          {/* Overlay for image to improve text readability */}
          {banner.imageUrl && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: bgColor,
                opacity: imageOpacity,
                borderRadius: '12px',
              }}
            />
          )}
          
          {/* Content */}
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '12px',
            }}
          >
            {/* Text Content */}
            <div style={{ flex: 1, minWidth: '200px' }}>
              <h6
                style={{
                  color: textColor,
                  fontSize: '16px',
                  fontWeight: 'bold',
                  margin: 0,
                  marginBottom: banner.subtitle ? '4px' : 0,
                }}
              >
                {banner.title || 'Banner Title'}
              </h6>
              {banner.subtitle && (
                <p
                  style={{
                    color: textColor,
                    fontSize: '14px',
                    margin: 0,
                    opacity: 0.9,
                  }}
                >
                  {banner.subtitle}
                </p>
              )}
            </div>

            {/* Button */}
            {banner.buttonText && (
              <button
                style={{
                  backgroundColor: buttonColor,
                  color: buttonTextColorFinal,
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  minWidth: '100px',
                }}
                disabled
              >
                {banner.buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionalBannerPreview;
